export const SALESHISTORY_LOADING = "SALESHISTORY_LOADING";
export const SALESHISTORY_RESET = "SALESHISTORY_RESET";
export const GET_SALESHISTORY = "GET_SALESHISTORY";
export const GET_SALESHISTORY_SUCCESS = "GET_SALESHISTORY_SUCCESS";
export const GET_SALESHISTORY_FAIL = "GET_SALESHISTORY_FAIL";
export const DELETE_SALESHISTORY = "DELETE_SALESHISTORY"
export const DELETE_SALESHISTORY_SUCCESS = "DELETE_SALESHISTORY_SUCCESS"
export const DELETE_SALESHISTORY_FAIL = "DELETE_SALESHISTORY_FAIL"
export const UPDATE_SALESHISTORY = "UPDATE_SALESHISTORY"
export const UPDATE_SALESHISTORY_SUCCESS = "UPDATE_SALESHISTORY_SUCCESS"
export const UPDATE_SALESHISTORY_FAIL = "UPDATE_SALESHISTORY_FAIL"
export const ADD_NEW_SALESHISTORY = "ADD_NEW_SALESHISTORY"
export const ADD_SALESHISTORY_SUCCESS = "ADD_SALESHISTORY_SUCCESS"
export const ADD_SALESHISTORY_FAIL = "ADD_SALESHISTORY_FAIL"